<script>
    import { onMount } from "svelte";
    import * as api from "../stores/workMng.store";
    import { store } from "../stores/workMng.store";
    import Menu from "../components/Menu.svelte";
    import Header from "../components/Header.svelte";
    import { push } from "svelte-spa-router";

    let pageSize = 100; // 한 번에 로드할 데이터 개수
    let currentPage = 0; // 현재 페이지

    onMount(() => {
        getData();
    });

    async function getData() {
        // 모든 데이터를 한 번에 가져옴
        currentPage = 0;
        $store.currentList = [];

        const response = await api.apiGetWorkMng($store.spt_se, $store.keyword);
        $store.workMngList = [];
        $store.workMngList = response;

        loadMore(); // 초기 데이터 로드
    }

    function loadMore() {
        const start = currentPage * pageSize;
        const end = start + pageSize;

        // 추가 데이터를 $store.currentList에 병합
        $store.currentList = [
            ...$store.currentList,
            ...$store.workMngList.slice(start, end),
        ];
        currentPage++;
    }

    // 스크롤 이벤트 핸들러
    function handleScroll(event) {
        const { scrollTop, scrollHeight, clientHeight } = event.target;

        // 스크롤이 끝에 도달하면 추가 데이터 로드
        if (scrollTop + clientHeight >= scrollHeight - 10) {
            if ($store.currentList.length < $store.workMngList.length) {
                loadMore();
            }
        }
    }

    function goToDetail(no) {
        push(`/WorkMngDtl/${no}`);
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-missing-attribute -->
<div>
    <Header title="작업중" background_color="#46785b" />

    <Menu />

    <div class="search-wrap search-wrap-double">
        <div class="search-wrapper">
            <div class="search-in">
                <input
                    type="text"
                    class="in-text"
                    bind:value={$store.keyword}
                    on:keydown={(e) => e.key === "Enter" && getData()}
                />
                <p class="search-btn" on:click={getData}>검색</p>
            </div>
        </div>
    </div>

    <div class="search-wrap">
        <div class="search-in">
            <div class="work-wrap">
                <div
                    class="work-box {$store.spt_se == '2' ? 'work-box-on' : ''}"
                    on:click={() => {
                        $store.spt_se = "2";
                        getData();
                    }}
                >
                    <p>M/H S/H</p>
                </div>
                <div
                    class="work-box {$store.spt_se == '3' ? 'work-box-on' : ''}"
                    on:click={() => {
                        $store.spt_se = "3";
                        getData();
                    }}
                >
                    <p>본납</p>
                </div>
                <div
                    class="work-box {$store.spt_se == '4' ? 'work-box-on' : ''}"
                    on:click={() => {
                        $store.spt_se = "4";
                        getData();
                    }}
                >
                    <p>A/S</p>
                </div>
                <div
                    class="work-box {$store.spt_se == '5' ? 'work-box-on' : ''}"
                    on:click={() => {
                        $store.spt_se = "5";
                        getData();
                    }}
                >
                    <p>기타</p>
                </div>
                <div
                    class="work-box {$store.spt_se == '6' ? 'work-box-on' : ''}"
                    on:click={() => {
                        $store.spt_se = "6";
                        getData();
                    }}
                >
                    <p>설치</p>
                </div>
                <div
                    class="work-box {$store.spt_se == '7' ? 'work-box-on' : ''}"
                    on:click={() => {
                        $store.spt_se = "7";
                        getData();
                    }}
                >
                    <p>완료</p>
                </div>
            </div>
        </div>
    </div>

    <div
        class="main scroll-custom"
        style="height: calc(100vh - 155px);"
        on:scroll={handleScroll}
    >
        {#if $store.currentList.length > 0}
            {#each $store.currentList as data, index}
                <div
                    class="main-in"
                    on:click={() => {
                        goToDetail(data.rcvord_no);
                    }}
                >
                    <!-- <p class="list-no">{index + 1}</p> -->
                    <p
                        class="list-title"
                        style="white-space: normal; color: {data.clos_at ==
                        'Y'
                            ? 'rgb(255,0,8)'
                            : '#3D3D3D'}"
                    >
                        {data.contents}
                        <br />
                        ({data.contents_proc}-{data.qy}장)

                        {#if data.outord_rm != ""}
                            <br />
                            (외주_{data.outord_rm})
                        {/if}
                    </p>
                </div>
            {/each}
        {:else}
            <div class="main-in" style="place-content: center;">
                <p style="font-size: 17px;">검색된 결과가 없습니다.</p>
            </div>
        {/if}
    </div>
</div>
